import _ from "lodash";
import BaseTileView from "scripts/views/baseTileView";
import ProgressBarView from "scripts/views/progressBarView";
import ProgressBarModel from "scripts/models/progressBarModel";

import templateContributor from "templates/contributorLink.hbs";

class BaseListTileView extends BaseTileView {
  get className() {
    return "bb-list-tile";
  }

  initializeBookshelfDeps() {
    super.initializeBookshelfDeps();

    this.progressBarModel = new ProgressBarModel();

    this.progressBarView = this.addSubView(
      new ProgressBarView({
        className: "bb-download-indicator-container list-version",
        model: this.progressBarModel,
      }),
    );

    this.progressBarView.on(
      "progressBarCancel",
      this.onCancelBookshelfDownload.bind(this),
      this,
    );
  }

  initializeContributors() {
    const $contributors = this.$el.find(".bb-list-tile-contributor-region");
    $contributors.empty();

    const contributors = this.model.get("contributors");
    if (contributors) {
      contributors.forEach(contributor => {
        contributor.searchContributorQueryParam = this.connectionService.isOnline()
          ? encodeURIComponent(`"${contributor.fullName}"`)
          : undefined;
        $contributors.append(templateContributor(contributor));
      });
    }
  }

  updateTitleLinkUrl() {
    this.$el.find(".bb-list-tile-title-link").attr("href", this.getDetailUrl());
  }

  onConnectionStatusChange() {
    super.onConnectionStatusChange();

    this.initializeContributors();
    this.updateTitleLinkUrl();
  }

  render() {
    const user = this.securityService.getUser();
    const modelData = this.model.toJSON();

    const templateData = _.merge(modelData, {
      viewerUrl: this.getViewerUrl(),
      detailUrl: this.getDetailUrl(),
      showBadges: user.getShowBadges(),
      downloadUrl: this.getDownloadUrl(),
    });

    this.$el.html(this.template(templateData));

    this.initDetailButton();
    this.initFavoriteButton();
    this.initCurationAddButton();
    this.initTooltips();
    this.initializeContributors();

    this.initializeDownloadButton();

    this.initializeCurationMultiSelect();

    return this;
  }

  renderBookshelfElements() {
    super.renderBookshelfElements();

    this.progressBarView
      .htmlOf(this.$el.find(".bb-download-progress-bar-region-list-tile"))
      .render();
  }

  updateProgressBar(percent) {
    this.progressBarModel.set("isVisible", true);

    this.progressBarModel.set("percent", percent);
  }

  hideProgressBar() {
    this.progressBarModel.set("isVisible", false);
  }

  checkFavoriteButton() {
    this.$el
      .find(".btn-favorite")
      .addClass("active")
      .find("i")
      .removeClass("bbico-favorite")
      .addClass("bbico-favorite-filled");
  }

  uncheckFavoriteButton() {
    this.$el
      .find(".btn-favorite")
      .removeClass("active")
      .find("i")
      .removeClass("bbico-favorite-filled")
      .addClass("bbico-favorite");
  }

  checkBookshelfButton() {
    this.$el
      .find(".btn-bookshelf")
      .addClass("active")
      .find("i")
      .removeClass("bbico-offline-bookshelf")
      .addClass("bbico-offline-bookshelf-filled");
  }

  uncheckBookshelfButton() {
    this.$el
      .find(".btn-bookshelf")
      .removeClass("active")
      .find("i")
      .addClass("bbico-offline-bookshelf")
      .removeClass("bbico-offline-bookshelf-filled");
  }

  addContributors(contributors) {
    const $contributors = this.$el.find(".bb-list-tile-contributor-region");

    contributors.forEach(contributor => {
      contributor.searchContributorQueryParam = encodeURIComponent(
          `"${contributor.fullName}"`,
      );
      $contributors.append(templateContributor(contributor));
    });
  }

  onClickFavoriteButton() {
    this.$el.find('[data-toggle="tooltip"]').tooltip("hide");

    const isFavorite = this.model.get("isFavorite");
    const favoriteButton = this.$el.find(".btn-favorite");

    const newTitleText = isFavorite ? "Favorite" : "Unfavorite";

    favoriteButton
      .attr("title", newTitleText)
      .attr("data-original-title", newTitleText);

    super.onClickFavoriteButton();

    return false;
  }
}

export default BaseListTileView;
